import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Paper,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "./api/apiClient"; // Axios instance

const MaintainMeeting = () => {
  const [title, setTitle] = useState("");
  const [scheduledAt, setScheduledAt] = useState("");
  const [inviteeName, setInviteeName] = useState("");
  const [inviteeEmail, setInviteeEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const initiatorId = localStorage.getItem("userId"); // assuming userId is stored after login

    try {
      const response = await apiClient.post("/meetings", {
        title,
        scheduledAt,
        inviteeName,
        inviteeEmail,
        initiatorId,
      });

      console.log("Meeting created successfully:", response.data);
      navigate("/meetings"); // Redirect to the meetings list
    } catch (error) {
      console.error("Error creating meeting:", error);
      alert("Failed to create meeting.");
    }
  };

  return (
    <Paper style={{ padding: 20, maxWidth: 600, margin: "auto", marginTop: 40 }}>
      <Typography variant="h6" gutterBottom>
        Create Meeting
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Meeting Title"
              fullWidth
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Scheduled At"
              type="datetime-local"
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
              value={scheduledAt}
              onChange={(e) => setScheduledAt(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Invitee Name"
              fullWidth
              required
              value={inviteeName}
              onChange={(e) => setInviteeName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Invitee Email"
              type="email"
              fullWidth
              required
              value={inviteeEmail}
              onChange={(e) => setInviteeEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button type="submit" variant="contained" color="primary">
              Create Meeting
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default MaintainMeeting;
